import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa';
import { toast } from 'react-hot-toast';
import Icon from '../../../components/common/Icon';

import { useServerSideTable } from '../../../hooks/useServerSideTable';
import { getPagedLawyers, deleteLawyer } from '../../../services/lawyerService';
import { Lawyer } from '../../../types/lawyer';
import { getLawyerColumns } from './LawyerColumns';

import Table from '../../../components/common/Table';
import ConfirmDialog from '../../../components/common/ConfirmDialog';
import pageStyles from '../../Page.module.css';
//import sharedStyles from '../../SharedPageStyles.module.css';
// أنشئ المكون هنا، خارج المكون الرئيسي للصفحة
interface TableHeaderProps {
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
}

// 2. استخدم هذه الواجهة في تعريف المكون
const TableHeader: React.FC<TableHeaderProps> = ({ searchTerm, setSearchTerm }) => {
  return (
    <div style={{ marginBottom: '1rem', maxWidth: '400px' }}>
      <input
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="ابحث في الجدول..."
        style={{ width: '100%', padding: '0.8rem', borderRadius: '6px', border: '1px solid #ccc' }}
      />
    </div>
  );
};
const LawyersListPage: React.FC = () => {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [lawyerToDelete, setLawyerToDelete] = useState<Lawyer | null>(null);

  const openDeleteDialog = (lawyer: Lawyer) => {
    setLawyerToDelete(lawyer);
    setIsDeleteDialogOpen(true);
  };

  const closeDeleteDialog = () => {
    setLawyerToDelete(null);
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    if (!lawyerToDelete) return;
    const promise = deleteLawyer(lawyerToDelete.id);
    toast.promise(promise, {
      loading: 'جاري حذف المحامي...',
      success: () => {
        closeDeleteDialog();
        refreshData();
        return 'تم حذف المحامي بنجاح!';
      },
      error: (err) => {
        closeDeleteDialog();
        return err.response?.data?.message || 'فشل في حذف المحامي.';
      },
    });
  };

  const columns = useMemo(() => getLawyerColumns(openDeleteDialog), []);

  const { table, isLoading, Pagination, refreshData, searchTerm, setSearchTerm } = useServerSideTable<Lawyer>({
    columns,
    fetchData: getPagedLawyers,
  });

  return (
    <div className={pageStyles.pageContainer}>
      <div className={pageStyles.pageHeader}>
        <h1>إدارة المحامين</h1>
        <Link to="/admin/lawyers/add" className={pageStyles.addButton}>
          <Icon as={FaPlus} style={pageStyles.icon } />
          
          <span>إضافة محامٍ</span>
        </Link>
      </div>
      <div className={pageStyles.pageContent}>
         <TableHeader searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        <Table<Lawyer> table={table} isLoading={isLoading} />
        <Pagination />
      </div>
      <ConfirmDialog
        isOpen={isDeleteDialogOpen}
        title="تأكيد الحذف"
        message={`هل أنت متأكد من رغبتك في حذف المحامي "${lawyerToDelete?.name}"؟`}
        onConfirm={handleDelete}
        onCancel={closeDeleteDialog}
      />
    </div>
  );
};

export default LawyersListPage;
